import {
  RiPuzzleFill,
  RiQuestionAnswerFill,
  RiFocus2Line,
  RiCompass3Fill,
  RiGuideFill,
  RiRobot2Line,
  RiCalendarEventLine,
} from '@remixicon/react';
import { Grid } from '@material-ui/core';
import { CardType, MinimalCard } from '@internal/backstage-plugin-hm-react';
import { useRouteRef } from '@backstage/frontend-plugin-api';
import {
  agentsRootRouteRef,
  contributeExternalRouteRef,
  qetaExternalRouteRef,
  techRadarExternalRouteRef,
  decisionMatrixExternalRouteRef,
  techSpotEventCalendarExternalRouteRef,
} from '../../routes';
import { Container } from '@backstage/ui';

export const ExploreLandingPageIcon = <RiCompass3Fill />;

export const ExploreLandingPage = () => {
  const agentsRegistry = useRouteRef(agentsRootRouteRef);
  const decisionMatrix = useRouteRef(decisionMatrixExternalRouteRef);
  const contribute = useRouteRef(contributeExternalRouteRef);
  const qetaPage = useRouteRef(qetaExternalRouteRef);
  const techRadar = useRouteRef(techRadarExternalRouteRef);
  const techSpotEventCalendar = useRouteRef(
    techSpotEventCalendarExternalRouteRef,
  );

  return (
    <Container>
      <Grid container spacing={3} direction="row">
        <Grid item sm={12} md={6} lg={3} xl={2}>
          <MinimalCard
            title="AI Agents Registry"
            type={CardType.tool}
            description="Browse and discover registered AI agents across H&M platforms."
            actionRoute={agentsRegistry?.()}
            Icon={RiRobot2Line}
            fullHeight
          />
        </Grid>

        <Grid item sm={12} md={6} lg={3} xl={2}>
          <MinimalCard
            title="BackOverflow"
            type={CardType.plugin}
            description="A platform for asking questions and sharing knowledge about
                Backstage and H&M tools & platforms."
            actionRoute={qetaPage?.()}
            Icon={RiQuestionAnswerFill}
            fullHeight
          />
        </Grid>

        <Grid item sm={12} md={6} lg={3} xl={2}>
          <MinimalCard
            title="Tech Radar"
            type={CardType.tool}
            description="Tech Radar displays the state of technologies used within H&M."
            actionRoute={techRadar?.()}
            Icon={RiFocus2Line}
            fullHeight
          />
        </Grid>

        <Grid item sm={12} md={6} lg={3} xl={2}>
          <MinimalCard
            title="TechSpot Event Calendar"
            type={CardType.tool}
            description="TechSpot Event Calendar displays upcoming tech-related events within H&M."
            actionRoute={techSpotEventCalendar?.()}
            Icon={RiCalendarEventLine}
            fullHeight
          />
        </Grid>

        <Grid item sm={12} md={6} lg={3} xl={2}>
          <MinimalCard
            title="Integration Architecture - Decision Matrix"
            type={CardType.tool}
            description="Comparing integration platforms using a drag-and-drop priority-based decision system."
            actionRoute={decisionMatrix?.()}
            Icon={RiGuideFill}
            fullHeight
          />
        </Grid>

        <Grid item sm={12} md={6} lg={3} xl={2}>
          <MinimalCard
            title="Plugin or Template Decision Guide"
            type={CardType.tool}
            description="Not sure whether to build a Backstage plugin or a scaffolder template? Answer a few quick questions and get a tailored recommendation."
            actionRoute={contribute?.()}
            Icon={RiPuzzleFill}
            fullHeight
          />
        </Grid>
      </Grid>
    </Container>
  );
};
